import React from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { BrandMark } from "./AuthLayout";
import { useAuth } from "../context/AuthContext";
import NotificationBell from "../components/NotificationBell";
import { useAppT, LanguageToggle } from "../components/home/i18n";
import { LogOut } from "lucide-react";

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const { a } = useAppT();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const onLogout = async () => { await logout(); navigate("/login"); };

  const TABS = [
    [a.layout.adminTabs.accounts, "/admin"],
    [a.layout.adminTabs.candidates, "/admin/candidates"],
    [a.layout.adminTabs.employers, "/admin/employers"],
    [a.layout.adminTabs.jobs, "/admin/jobs"],
    [a.layout.adminTabs.applications, "/admin/applications"],
    [a.layout.adminTabs.videos, "/admin/videos"],
    [a.layout.adminTabs.community, "/admin/community"],
    [a.layout.adminTabs.backups, "/admin/backups"],
    [a.layout.adminTabs.requests, "/admin/account-requests"],
  ];

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <header className="border-b border-[#E8E4DB] bg-white">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-2 px-5 py-3">
          <div className="flex items-center gap-3"><BrandMark /><span className="rounded-full bg-[#8B3A3A] px-2.5 py-0.5 text-[11px] font-semibold text-white">{a.layout.adminBadge}</span></div>
          <div className="flex items-center gap-2 sm:gap-3">
            <LanguageToggle testid="dash-lang-toggle" variant="dark" />
            <NotificationBell />
            <div className="hidden text-right sm:block"><div className="text-sm font-medium text-[#2C2A29]">{user?.name}</div><div className="text-[11px] text-[#5C5855]">{user?.email}</div></div>
            <button data-testid="logout-btn" onClick={onLogout} className="flex items-center gap-1 rounded-sm border border-[#E8E4DB] px-3 py-2 text-sm text-[#8B3A3A] hover:bg-[#8B3A3A]/5"><LogOut className="h-4 w-4" /> <span className="hidden sm:inline">{a.layout.logout}</span></button>
          </div>
        </div>
        <div className="mx-auto flex max-w-6xl gap-1 overflow-x-auto px-5">
          {TABS.map(([label, to]) => (
            <Link key={to} to={to} data-testid={`admin-tab-${to.split("/").pop() || "root"}`}
              className={`-mb-px shrink-0 whitespace-nowrap border-b-2 px-4 py-2.5 text-sm ${pathname === to ? "border-[#1F4A38] font-semibold text-[#1F4A38]" : "border-transparent text-[#5C5855] hover:text-[#2C2A29]"}`}>{label}</Link>
          ))}
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-8">{children}</main>
    </div>
  );
}
